import { useQuery } from "@tanstack/react-query";
import { fetchQuizQuestions, generateQuiz } from "../services/quiz";
import { QUERY_CONSTANTS } from "../constants/query-constants";
import { useCookieConsent } from "../contexts/CookieConsentContext";
import { QuizData } from "../types/Quiz";
import { useMemo } from "react";

export const useQuizQuestions = () => {
    const { hasConsented } = useCookieConsent();

    return useQuery<QuizData>({
        queryKey: ["quizQuestions", hasConsented],
        queryFn: fetchQuizQuestions,
        staleTime: QUERY_CONSTANTS.STALE_TIME,
        refetchInterval: QUERY_CONSTANTS.REFETCH_INTERVAL,
        enabled: hasConsented,
    });
};

export const useGeneratedQuiz = () => {
    const { data: quizData, ...rest } = useQuizQuestions();

    const generatedQuiz = useMemo(() => {
        return quizData ? generateQuiz(quizData) : [];
    }, [quizData]);

    return {
        ...rest,
        data: generatedQuiz,
    };
};
